<template>
	<div class="mod-resetpwd">
		<mini-header></mini-header>
		<div class="reset-main">
			<div class="mod-title">
				<h1>忘记密码</h1>
				<span class="under-line"></span>
			</div>
			<div class="form_panel">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
					<input type="password" hidden autocomplete="new-password" />
					<el-form-item label="手机号码" prop="phone">
						<el-input v-model="ruleForm.phone"></el-input>
					</el-form-item>
					<el-row :gutter="18">
						<el-col :span="15">
							<el-form-item label="验证码" prop="captcha_phone">
								<el-input v-model="ruleForm.captcha_phone"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="9">
							<div class="getcaptcha" @click="getCaptchaHandle">
								<span v-show="showCaptcha">获取验证码</span>
								<span v-show="!showCaptcha">{{ count }}s后重新发送</span>
							</div>
						</el-col>
					</el-row>
					<el-form-item label="邮箱" prop="email">
						<el-input v-model="ruleForm.email"></el-input>
					</el-form-item>
					<el-form-item label="真实姓名" prop="name">
						<el-input v-model="ruleForm.name"></el-input>
					</el-form-item>
					<el-form-item label="身份证号" prop="IDNumber">
						<el-input v-model="ruleForm.IDNumber"></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="password">
						<el-input type="password" name="A6" style="position: fixed; bottom: -9999999px"></el-input>
						<el-input type="password" name="A6" v-model="ruleForm.password" autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly')"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="comfirmPassword">
						<el-input type="password" name="A7" style="position: fixed; bottom: -9999999px"></el-input>
						<el-input type="password" name="A7" v-model="ruleForm.comfirmPassword" autocomplete="new-password" readonly onfocus="this.removeAttribute('readonly')"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" class="subbtn" round @click="submitForm('ruleForm')">确定</el-button>
						<el-button round class="callbackbtn" @click="$router.push({ name: 'login' })">返回登录</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import { isMobile, isEmail, validateIdNo } from '@/utils/validate'
import { RSAEncrypt } from '@/utils'
import MiniHeader from './../common/mini-header.vue'
export default {
	components: {
		MiniHeader,
	},
	data() {
		var validateMobile = (rule, value, callback) => {
			if (!isMobile(value)) {
				callback(new Error('手机号格式错误'))
			} else {
				callback()
			}
		}
		var validateEmail = (rule, value, callback) => {
			if (!isEmail(value)) {
				callback(new Error('邮箱格式错误'))
			} else {
				callback()
			}
		}
		var validatePassword = (rule, value, callback) => {
			const reg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,16}/
			if (value == '' || value == undefined || value == null) {
				callback()
			} else {
				if (!reg.test(value)) {
					callback(new Error('仅由英文字母，数字以及特殊字符组成，6到16位'))
				} else {
					callback()
				}
			}
		}
		// var validateComfirmPassword = (rule, value, callback) => {
		//   if (!/\S/.test(value)) {
		//     callback(new Error("确认密码不能为空"));
		//   } else if (this.ruleForm.password !== value) {
		//     callback(new Error("确认密码与密码输入不一致"));
		//   } else {
		//     callback();
		//   }
		// };
		return {
			ruleForm: {
				phone: '',
				captcha_phone: '',
				email: '',
				name: '',
				IDNumber: '',
				password: '',
				comfirmPassword: '',
			},
			rules: {
				phone: [
					{ required: true, message: '请输入手机号码', trigger: 'blur' },
					{ validator: validateMobile, trigger: 'blur' },
				],
				captcha_phone: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				email: [
					{ required: true, message: '请输入邮箱', trigger: 'blur' },
					{ validator: validateEmail, trigger: 'blur' },
				],
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				IDNumber: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
					{ validator: validateIdNo, trigger: 'blur' },
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ validator: validatePassword, trigger: 'blur' },
				],
				comfirmPassword: [
					{ required: true, message: '请输入确认密码', trigger: 'blur' },
					{ validator: validatePassword, trigger: 'blur' },
				],
			},
			showCaptcha: true,
			count: '',
			timer: null,
		}
	},
	methods: {
		// 获取验证码基于手机号
		getCaptchaHandle() {
			this.$refs['ruleForm'].validateField('phone', valid => {
				if (!valid) {
					let params = {
						phone: this.ruleForm.phone,
					}
					this.$http.post(this.$api.shiroApi.sendCaptchaByPhone, params).then(({ data }) => {
						console.log(data)
						if (data.code === 200) {
							this.countdown(60)
						}
					})
				}
			})
		},
		// 表单提交
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.password != this.ruleForm.comfirmPassword) {
						this.$message.warning('确认密码与密码输入不一致')
						return
					}
					let params = {
						phone: this.ruleForm.phone,
						captcha_phone: this.ruleForm.captcha_phone,
						email: this.ruleForm.email,
						name: this.ruleForm.name,
						IDNumber: this.ruleForm.IDNumber,
						password: RSAEncrypt(this.ruleForm.password),
					}
					this.$http.post(this.$api.shiroApi.reset, params).then(({ data }) => {
						if (data.code === 200) {
							this.$message({
								message: '修改密码成功！',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.$router.replace({ name: 'login' })
								},
							})
						}
					})
				}
			})
		},
		// 倒计时
		countdown(second) {
			const TIME_COUNT = second
			if (!this.timer) {
				this.count = TIME_COUNT
				this.showCaptcha = false
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--
					} else {
						this.showCaptcha = true
						clearInterval(this.timer)
						this.timer = null
					}
				}, 1000)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.mod-resetpwd {
	.reset-main {
		width: 1200px;
		margin: 30px auto 50px auto;
		padding: 32px;
		min-height: 500px;
		background: #fff;
		.mod-title {
			h1 {
				font-size: 24px;
			}
		}
		.form_panel {
			width: 650px;
			margin: 50px auto;
			.getcaptcha {
				height: 50px;
				line-height: 50px;
				color: #999;
				border: 1px solid #ccc;
				text-align: center;
				cursor: pointer;
			}
			.subbtn {
				width: 160px;
				height: 50px;
				border-radius: 30px;
				background: #1460ae;
			}
			.callbackbtn {
				height: 50px;
				width: 160px;
				border-radius: 30px;
			}
		}
	}
}
</style>
